import React, { useEffect } from 'react';

import LoginPage from '@pray/shared/components/auth/LoginOptionsPage/LoginOptionsPage';
import Button from '@pray/shared/components/ui/Button';

import { EVENTS } from 'constants.js';
import usePrayContext from 'hooks/usePrayContext';

import { HUBSPOT_STEP_VIEW_EVENT_NAMES } from '../utils/constants';
import { hubspotTrackStepView } from '../utils/step-tracking';

export default function EmailOnboardingStep({ onContinue, onBack, ...props }) {
  const { title, subtitle, hasLogo, hasAppBar, showBackButton, showSkipButton, logo } = props;
  const { isUserRegistered } = usePrayContext();

  useEffect(() => {
    hubspotTrackStepView(HUBSPOT_STEP_VIEW_EVENT_NAMES.LOGIN);
  }, []);

  useEffect(() => {
    if (isUserRegistered) {
      onContinue({ isSkipped: true });
    }
  }, [isUserRegistered]);

  const skipButton = (
    <Button style={{ paddingRight: 0 }} onClick={() => onContinue({ isSkipped: true })}>
      Skip
    </Button>
  );

  // Avoiding flickering
  if (isUserRegistered) {
    return null;
  }

  return (
    <LoginPage
      title={title}
      subtitle={subtitle}
      route="/get-started"
      logo={logo}
      isShowSubtitle
      isShowLogo={hasLogo}
      isShowAppBar={hasAppBar}
      isWebSubscribeFlow={false}
      registerViewName={EVENTS.PRAY_EVENTS.VIEW_EVENT_NAMES.ONBOARDING_FLOW.LOGIN_STEP}
      appBarRightComponent={showSkipButton && skipButton}
      onSuccess={onContinue}
      onBack={showBackButton && onBack}
    />
  );
}
